import React from 'react';
import { calculateDeadline } from '../../utils/helpers';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { clsx } from 'clsx';

const TimerCard = ({ label, startDate, days, legalBasis }) => {
  const { deadlineDate, daysRemaining, isOverdue, severity } = calculateDeadline(startDate, days);

  return (
    <div className={clsx(
      "p-3 rounded-lg border flex flex-col justify-between h-full transition-all",
      isOverdue ? "bg-red-50 border-red-200" : severity === 'warning' ? "bg-amber-50 border-amber-200" : "bg-slate-50 border-slate-200"
    )}>
      <div className="flex justify-between items-start mb-2">
        <span className="text-[10px] font-bold uppercase text-slate-500 tracking-wider font-mono">{legalBasis}</span>
        {isOverdue && <span className="text-[10px] font-bold text-red-600 animate-pulse">BREACH</span>}
      </div>
      
      <h4 className="text-xs font-bold text-slate-800 leading-tight mb-2">{label}</h4>
      
      <div className="flex items-end justify-between">
        <div className="text-xs text-slate-500">
          Due: <span className="font-semibold">{deadlineDate}</span>
        </div>
        <div className={clsx(
          "text-sm font-black",
          isOverdue ? "text-red-700" : severity === 'warning' ? "text-amber-700" : "text-grn-navy"
        )}>
          {isOverdue ? `+${Math.abs(daysRemaining)}d` : `${daysRemaining}d`}
        </div>
      </div>
    </div>
  );
};

export const ComplianceTimers = ({ project }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      <TimerCard 
        label="Award Publication" 
        startDate={project.startDate} 
        days={7} 
        legalBasis="PP Regs 2017" 
      />
      <TimerCard 
        label="PPU Acknowledgment" 
        startDate={project.startDate} 
        days={7} 
        legalBasis="PPA S.7(4)" 
      />
      <TimerCard 
        label="NDP6 Quarterly Report" 
        startDate="2024-12-31" 
        days={30} 
        legalBasis="NDP6 IMEP" 
      />
    </div>
  );
};